import { render } from "./Alert3.vue?vue&type=template&id=46922ca2"
import script from "./Alert3.vue?vue&type=script&lang=js"
export * from "./Alert3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__